window.browserDetails = window.browserDetails || {};

(function (browserDetails) {
	/* function privateBla() {
	 console.log('BLA');
	} */

	browserDetails.isSupported = function () {
		// npx browserslist@latest --update-db
		// change .browserslistrc to use the strict variant
		// npx browserslist-useragent-regexp --allowHigherVersions
		const supportedUserAgentsRegEx =
			/Edge?\/(1{2}[3-9]|1[2-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Firefox\/(1{2}[3-9]|1[2-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(1{2}[3-9]|1[2-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(16\.([5-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/(9{2}|\d{3,})\.\d+\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(15[._]([6-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android.+Chrom(ium|e)\/(1{2}[4-9]|1[2-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|SamsungBrowser\/(2[1-9]|[3-9]\d|\d{3,})\.\d+/;
		const isSupportedUserAgent = supportedUserAgentsRegEx.test(navigator.userAgent) === true;
		const hasModernFeatures =
			'Promise' in window && 'flat' in Array.prototype && 'customElements' in window && 'Intl' in window && 'DateTimeFormat' in Intl;
		return isSupportedUserAgent && hasModernFeatures;
	};

	browserDetails.features = {
		hasStorageAccessStored: null,

		init: function () {
			/* if (this.hasStorageAccess()) { // Will ich erstmal nicht so gerne, das verleitet dazu wieder auf das domElement zuzugreifen. Lieber hasStorageAccess() benutzen, bzw. das appState.set/get
			 document.querySelector('html').classList.add('localstorage');
			}*/

			if ('ontouchstart' in window) {
				document.querySelector('html').classList.add('touchevents');
			} else {
				document.querySelector('html').classList.add('no-touchevents');
			}
		},

		hasStorageAccess: function () {
			if (this.hasStorageAccessStored === null) {
				try {
					localStorage.setItem('featureTest', 'true');
					localStorage.removeItem('featureTest');
					this.hasStorageAccessStored = true;
					return true;
				} catch {
					this.hasStorageAccessStored = false;
					return false;
				}
			} else {
				return this.hasStorageAccessStored;
			}
		},
	};

	browserDetails.userAgent = {
		init: function () {
			if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
				document.querySelector('html').classList.add('ios');
			}

			const isMacSafari = /^((?!chrome|android|iPad|iPhone|iPod).)*safari/i.test(navigator.userAgent);
			if (isMacSafari) {
				// BUG-16234
				document.querySelector('html').classList.add('macSafari');
			}

			/* if(/Android/.test(navigator.userAgent)) {
			 document.querySelector('html').classList.add('android');
			}
			if(navigator.userAgent.match(/Edge/i))) {
			 document.querySelector('html').classList.add('edge');
			}*/
		},
	};

	browserDetails.legacyInfo = {
		show: function () {
			const _this = this;
			if (document.querySelector('#legacyBrowser') !== null) {
				let userDidNotCloseBar = false;
				if (browserDetails.features.hasStorageAccess()) {
					userDidNotCloseBar = sessionStorage.getItem('hideLegacyBrowserBar') !== 'true';
				}

				if (userDidNotCloseBar && browserDetails.isSupported() === false) {
					document.querySelector('html').classList.add('legacybrowser');

					document.querySelector('#legacyBrowser .hideInfoBar').addEventListener('click', function () {
						_this.hide();
					});
				}
			}
		},

		hide: function () {
			document.querySelector('html').classList.remove('legacybrowser');

			if (browserDetails.features.hasStorageAccess()) {
				sessionStorage.setItem('hideLegacyBrowserBar', 'true');
			}
		},
	};

	(function init() {
		browserDetails.features.init();
		browserDetails.userAgent.init();

		document.addEventListener('ajaxShellPage:loadingDone', function () {
			// Events: No abortSignal needed
			browserDetails.legacyInfo.show();
		});
		document.addEventListener('DOMContentLoaded', function () {
			// Events: No abortSignal needed
			browserDetails.legacyInfo.show();
		});
	})(); // sofort ausführen
})(window.browserDetails);
